







































































































































































































































































































































import _ from 'lodash'
import Component, {mixins} from 'vue-class-component'
import DepartmentTypeSelect from '@/modules/reservation/components/DepartmentTypeSelect.vue';
import moment from 'moment';
import DepartmentType from '@/modules/reservation/model/DepartmenType';
import Period from 'date-period';
import {
    createReservation,
    getDepartmentPagination,
    getReservationPagination,
    ReservationDateRange,
    ReservationPaginationFilters,
    getReservationPrice,
} from '@/modules/reservation/api';
import Department from '@/modules/reservation/model/Department';
import {Ref, Watch} from 'vue-property-decorator';
import {DateMixin} from '@/modules/core/date';
import Reservation, {ReservationPaymentMethod} from '@/modules/reservation/model/Reservation';
import ReservationCell from '@/modules/reservation/components/ReservationCell.vue';
import {ReservationHourRange} from '@/modules/reservation/model/ReservationHourRange';
import UserSelect from '@/modules/user/components/UserSelect.vue';
import User from '@/modules/user/model/User';
import ServiceSelect from '@/modules/reservation/components/ServiceSelect.vue';
import EventSelect from '@/modules/reservation/components/EventSelect.vue';
import {VForm} from '@/types';
import Service from '@/modules/reservation/model/Service';
import Event from '@/modules/reservation/model/Event';
import {AxiosError} from 'axios';
import {State} from 'vuex-class';
import Wamp from '@/modules/core/wamp/mixins/Wamp';
import KeyValuePair from '@/modules/core/support/KeyValuePair';
import PrintReservation from "@/modules/reservation/components/PrintReservation.vue";

interface CreateReservationsOptions {
    user?: User,
    services: Service[]
    event: Event
    paymentMethod: ReservationPaymentMethod
}

function initialDate () {
    return moment().hours(0).minutes(0).seconds(0).milliseconds(0).toDate()
}

/**
 * Grilla que muestra las reservas por horas
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {PrintReservation, EventSelect, ServiceSelect, UserSelect, ReservationCell, DepartmentTypeSelect},
})
export default class ReservationGrid extends mixins(DateMixin, Wamp) {
    /**
     * Lista de eventos de reservas registrados en la aplicación. Esta lista es
     * utilizada para mostrar la barra inferior con la leyenda de colores
     * de los eventos
     */
    @State(state => state.reservation.events)
    public events: Event[]

    @Ref()
    public readonly tableContainer: HTMLDivElement

    /**
     * Referencia al component <v-form> de Vuetify. Permite ejecutar la
     * validación de sus campos
     */
    @Ref()
    public readonly newReservationsForm: VForm

    /**
     * Día actualmente seleccionado por el usuario
     */
    public currentDay = initialDate()

    /**
     * Departamento actualmente seleccionado por el usuario
     *
     * @var { DepartmentType | null }
     */
    public currentDepartmentType: DepartmentType | null = null

    /**
     * Lista con los departamentos del tipo seleccionado por el usuario
     * en la interfaz
     */
    public departments: Department[] = []

    /**
     * Lista de reservas cargadas del día actualmente seleccionado por el usuario.
     */
    public reservations: Reservation[] = []

    public currentNewReservation: Reservation | null = null

    /**
     * Controla la visibilidad del menú que muestra el selector para que el usuario
     * pueda seleccionar la fecha de la cual desea mostrar las reservas.
     *
     * Si es "true" el menú se mostrada, de lo contrario no aparecerá.
     */
    public datepickerMenu = false

    /**
     * Indica si la grilla se encuentra creado reservas en el servidor
     */
    public creating = false

    /**
     * Controla la visibilidad del la barra inferior, encargada de mostrar
     * la leyenda de colores de los eventos registrados en la
     * aplicación
     */
    public displayColorLegend = true

    /**
     * Controla la visibilidad del coalendario secundario, 
     * que se mostrara a la derecha de la tabla de reservas
     */
    public displaySecondaryCalendar = false;

    public loadingPrice = false

    /**
     * Observa la propiedad "displayColorLegend" que controla la visibilidad de la barra
     * inferior. Cuando el valor es modificado por el usuario el valor es almacenado
     * en el localStorage para mantener la configuración al salir de la app.
     *
     * También recalcula el tamaño de las celdas
     */
    @Watch('displayColorLegend')
    public watchDisplayColorLegend (value: boolean) {
        localStorage.setItem('config.reservation.grid.displayColorLegend', JSON.stringify(value))
    }

    /**
     * Observa la propiedad "displaySecondaryCalendar" que controla la visibilidad
     * del calendario secundario. 
     */
    @Watch('displaySecondaryCalendar')
    public watchDisplaySecondaryCalendar (value: boolean) {
        localStorage.setItem('config.reservation.grid.displaySecondaryCalendar', JSON.stringify(value))
    }


    /**
     * Reglas de validación para el formulario que rellena los campos necesarios
     * para la creación de la reservas
     */
    public get newReservationsValidationRules () {
        return {
            user: [
                // Comprueba que todas las reservas tengan configurado un usuario o
                // que al menos el se haya configurado un usuario general para
                // todas las reservas
                () => {
                    const user = this.createReservationsOptions.user
                    if (user && !user.isNew) {
                        return true
                    }

                    return this.newReservations.every(r => r.user && !r.user.isNew)
                        || 'El usuario al que se asignará la reserva es obligatorio'
                },
            ],
            event: [
                // Comprueba que todas las reservas tengan configurado un evento o
                // que al menos el se haya configurado un evento general para
                // todas las reservas
                () => {
                    const event = this.createReservationsOptions.event
                    if (event && !event.isNew) {
                        return true
                    }

                    return this.newReservations.every(r => r.event && !r.event.isNew) || 'El evento es obligatorio'
                },
            ],
        }
    }

    /**
     * Lista de generadas en base a las horas seleccionadas por el usuario en la
     * grilla
     */
    public newReservations: Reservation[] = []

    public newReservationsDialog = false

    public loading = false

    public userSelect = false

    public createReservationsOptions: CreateReservationsOptions = {
        user: new User(),
        services: [],
        event: new Event(),
        paymentMethod: ReservationPaymentMethod.None,
    }

    public paymentMethods = [
        {
            key: ReservationPaymentMethod.None,
            text: 'No generar pago',
            icon: 'mdi-close',
        },
        {
            key: ReservationPaymentMethod.Card,
            text: 'Pago con tarjeta de crédito',
            icon: 'mdi-credit-card-outline',
        },
        {
            key: ReservationPaymentMethod.Cash,
            text: 'Pago en efectivo',
            icon: 'mdi-cash',
        },
    ]

    /**
     * Celdas seleccionadas por el usuario
     */
    public selected: Array<{
        key: string,
        range: ReservationHourRange,
        department: Department,
    }> = []

    public cellHeight = '10px'

    /**
     * Calcula el color del texto que muestra el nombre del evento en la barra inferior de la grilla
     */
    public eventTextColor (event: Event) {
        const color = event.color
        if (!color) {
            return 'black'
        }

        const rgb = color.match(/^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*(\d*(?:\.\d+)?)\)$/)
        if (!rgb) {
            return 'black'
        }

        rgb.shift()

        const brightness = Math.round(((parseInt(rgb[0], 10) * 299) +
            (parseInt(rgb[1], 10) * 587) +
            (parseInt(rgb[2], 10) * 114)) / 1000);

        return (brightness > 125) ? 'black' : 'white';
    }

    /**
     * Estilos calculados para el contenedor de la tabla de reservas.
     */
    public get tableContainerStyle () {
        const containerHeight = '89vh'
        let offset = 0

        if (this.$vuetify.breakpoint.lgAndDown) {
            offset += 35
        }

        offset += (this.displayColorLegend ? 50 : 2)

        return {
            height: `calc(${containerHeight} - ${offset}px)`,
            position: 'relative',
            overflow: 'hidden',
        }
    }

    /**
     * Adaptamos el ancho de las reservas segun se muestre o no el calendario secundario
     */
    public get tableWithCalendarCols () {
        
        let cols = (this.displaySecondaryCalendar ? 9 : 12)
        return cols;
        
    }

    /**
     * Observa el tipo de departamento seleccionado por el usuario y cuando
     * este carga solicita a la API la lista de departamentos
     * para el nuevo tipo seleccionado
     */
    @Watch('currentDepartmentType')
    public async watchDepartmentType () {
        await this.loadDepartments()
        await this.loadReservations()
    }

    @Watch('currentDay', {immediate: true})
    public watchCurrentDay () {
        this.debouncedLoadReservations()
    }

    /**
     * Retorna la fecha actualmente seleccionada por el usuario en formato ISO
     * YYYY-mm-dd. Propiedad computada utilizada por el VDatepicker
     * para actualizar su fecha mostrada
     */
    public get formattedCurrentDay () {
        const date = this.currentDay

        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
    }

    /**
     * Recibe una fecha en formato ISO y crea un objeto Date. Setter invocado
     * cuando VDatepicker actualiza su valor
     */
    public set formattedCurrentDay (format: string) {
        this.currentDay = moment(format).hours(0).minutes(0).seconds(0).milliseconds(0).toDate()
    }

    /**
     * Genera una lista con las horas disponibles para el departamento
     */
    public get hours (): ReservationHourRange[] {
        const departmentType = this.currentDepartmentType
        // El usuario no ha seleccionado ningún departamento no es posible
        // genera la lista de horas
        if (!departmentType) {
            return []
        }

        // El departamento no posee fecha de apertura o cierre, no se puede generar el
        // rango de horas
        if (!departmentType.closingTime || !departmentType.openingTime) {
            return []
        }

        // Retorna una fecha con el tiempo del formato
        const setTime = (date: Date, format: string, forceNextDay = false) => {
            const time = moment(format, 'HH:mm')
            // Comprueba si es necesario añadir un día mas a la fecha
            const nextDay = (
                forceNextDay &&
                (
                    (time.hour() === date.getHours())
                        ? time.minutes() < date.getMinutes()
                        : time.hours() < date.getHours()
                )
            )

            const m = moment(date).set({hours: time.hours(), minutes: time.minutes()})

            return (nextDay ? m.add(1, 'day') : m).toDate()
        }

        // La fecha seleccionada por el usuario o el día de hoy si todavía no ha seleccionado
        // ninguna
        const date = this.currentDay

        const openingTime = setTime(date, departmentType.openingTime)
        const closingTime = setTime(openingTime, departmentType.closingTime, true)

        const period = Period({
            start: openingTime,
            end: closingTime,
            duration: `PT${departmentType.duration}S`,
        })

        return period.toArray().map((start, index, period) => {
            const end = period[index + 1] || closingTime
            const format = (date: Date) => moment(date).format('HH:mm')

            const isNextDay = moment(end).isAfter(period[0], 'date')

            return {
                text: `de ${format(start)} a ${format(end)}${isNextDay ? ' del día siguiente' : ''}`,
                start,
                end,
                index,
                isNextDay,
                availabilityRange: new ReservationDateRange(start, end),
                available: false,
                disabled: false,
            }
        })
    }

    /**
     * Selecciona una hora de la grilla
     */
    public select (range: ReservationHourRange, department: Department) {
        // Ya existe una reserva para el rango de horas, no se puede seleccionar
        if (this.getReservationByHour(range.start, range.end, department)) {
            return
        }

        const key = `${department.id}_${range.availabilityRange.key}`
        const index = this.selected.findIndex(s => s.key === key)
        index === -1
            ? this.selected.push({key, range, department})
            : this.selected.splice(index, 1)

        this.$forceUpdate()
    }

    /**
     * Elimina una de las horas seleccionadas por el usuario en la grilla
     */
    public removeSelected (key: string, removeFromNewReservationsList = true, closeSelectionDialogIfEmpty = true) {
        const index = this.selected.findIndex(s => s.key === key)
        const reservation = this.newReservations.findIndex(r => r.correlationId === key)

        // Elimina una de las horas seleccionadas por el usuario en la grilla
        // también elimina la reserva en la lista de la vista previa
        // en el caso de que esta ya haya sido generada
        index !== -1 && this.selected.splice(index, 1)
        if (removeFromNewReservationsList) {
            reservation !== -1 && this.newReservations.splice(reservation, 1)
        }

        this.selected.length === 0 && closeSelectionDialogIfEmpty && (this.newReservationsDialog = false)
        // Elimina también la reserva si el usuario la esta editando
        if (this.currentNewReservation && this.currentNewReservation.correlationId === key) {
            this.currentNewReservation = null
        }
    }

    /**
     * Limpia la lista de horas seleccionadas
     */
    public clearSelected () {
        this.selected = []
    }

    public isSelected (range: ReservationHourRange, department: Department) {
        const key = `${department.id}_${range.availabilityRange.key}`
        return !!this.selected.find(s => s.key === key)
    }

    /**
     * Busca una reserva que coincida con las horas y departamento argumentado.
     * Si no existe el resultado será nulo.
     */
    public getReservationByHour (start: Date, end: Date, department: Department) {
        return this.reservations.find(reservation =>
            reservation.isBetweenHours(start, end)
            && department.id === reservation.department.id,
        ) || null
    }

    /**
     * Pasa al día siguiente
     */
    public nextDay () {
        const date = moment(this.currentDay)
        date.add(1, 'day')

        this.currentDay = date.toDate()
    }

    /**
     * Vuelve al día anterior
     */
    public previousDay () {
        const date = moment(this.currentDay)
        date.subtract(1, 'day')

        this.currentDay = date.toDate()
    }

    /**
     * Genera una lista de reservas en base a las horas seleccionadas por el usuario
     * en la grilla
     */
    public generateNewReservations () {
        this.newReservations = this.selected.map(selectedHour => {
            const reservation = new Reservation()
            reservation.dateStart = selectedHour.range.start
            reservation.dateEnd = selectedHour.range.end
            reservation.department = selectedHour.department
            reservation.correlationId = selectedHour.key
            reservation.hourRange = selectedHour.range

            return reservation
        })

        this.newReservationsDialog = true
    }

    public getReservationField (path: string) {
        switch (path) {
            // Si la reserva define un usuario se retornará este, si no, se retornará el usuario
            // general para todas las reservas
            case 'user':
                return this.currentNewReservation && this.currentNewReservation.user && !this.currentNewReservation.user.isNew
                    ? this.currentNewReservation.user
                    : this.createReservationsOptions.user
            case 'services':
                return this.currentNewReservation ? this.currentNewReservation.services : this.createReservationsOptions.services
            case 'event':
                return this.currentNewReservation && this.currentNewReservation.event && !this.currentNewReservation.event.isNew
                    ? this.currentNewReservation.event
                    : this.createReservationsOptions.event
            case 'paymentMethod':
                return this.currentNewReservation && !!this.currentNewReservation.paymentMethod
                    ? this.currentNewReservation.paymentMethod
                    : this.createReservationsOptions.paymentMethod
            default:
                return _.get(
                    this.currentNewReservation,
                    path,
                    _.get(this.createReservationsOptions, path),
                )
        }
    }

    public async updateServices (services: Service[]) {
        this.updateReservationField('services', services)
        await this.loadReservationPrice()
    }

    /**
     * Actualiza uno de los campos para las opciones de creación de nuevas reservas
     */
    public updateReservationField (path: string, value: any) {
        if (this.currentNewReservation) {
            _.set(this.currentNewReservation, path, value)

            return
        }

        _.set(this.createReservationsOptions, path, value)
    }

    /**
     * Carga los departamentos del tipo seleccionado por el usuario
     */
    public async loadDepartments () {
        this.loading = true
        if (!this.currentDepartmentType) {
            return []
        }

        const result = await getDepartmentPagination({
            page: 1,
            recordsPerPage: 999,
            orderBy: [
                {field: 'type', direction: 'DESC'},
                {field: 'name', direction: 'ASC'},
            ],
            filters: {
                type: this.currentDepartmentType.id,
                orderNumericName: true,
            },
        })

        this.departments = result.items
        this.loading = false
    }

    public get debouncedLoadReservations () {
        return _.debounce(() => this.loadReservations(), 500)
    }

    /**
     * Carga todas las reservas del día
     */
    public async loadReservations () {
        // El usuario no ha seleccionado ningún tipo de departamento
        if (!this.currentDepartmentType) {
            return
        }

        this.loading = true

        const filters = new ReservationPaginationFilters()
        filters.departmentType = this.currentDepartmentType.id
        filters.startDate = this.currentDay
        filters.endDate = this.currentDay

        if (this.currentDepartmentType.closesNextDay) {
            filters.endDate = moment(this.currentDay).add(1, 'day').toDate()
        }

        const result = await getReservationPagination({
            page: 1,
            recordsPerPage: 999,
            filters,
        })

        this.reservations = result.items
        this.loading = false

        this.$forceUpdate()
    }

    /**
     * Solicita al servidor la creación de la lista de reservas en base
     */
    public async createReservations () {
        if (!this.newReservationsForm.validate()) {
            return
        }

        this.creating = true
        // Itera sobre la lista de reservas para insertar los datos necesarios
        const promises = this.newReservations.map(reservation => {
            // La reserva ya ha sido creada correctamente
            if (reservation.status === 'success') {
                return new Promise(resolve => resolve(reservation))
            }

            // Si la reserva no especifica ningún se utilizará el usuario configurado
            // en las opciones generales
            if (reservation.user.isNew) {
                reservation.user = this.createReservationsOptions.user as User
            }

            // Si la reserva no especifica un evento propio, utilizará el evento configurado
            // en las opciones generales
            if (reservation.event.isNew) {
                reservation.event = this.createReservationsOptions.event
            }

            // Si la reserva no especifica un método de pago propio, utilizará el método de pago
            // configurado en las opciones generales
            if (!reservation.paymentMethod) {
                reservation.paymentMethod = this.createReservationsOptions.paymentMethod
            }

            if (!reservation.services.length) {
                reservation.services = this.createReservationsOptions.services
            }

            return createReservation(reservation)
                .then(r => {
                    reservation.status = 'success'
                    reservation.id = r.id
                    reservation.payment = r.payment

                    this.reservations.push(r)
                    this.removeSelected(reservation.correlationId!.toString(), false, false)
                    this.notifyNewReservation(r)
                })
                .catch((error: Error) => {
                    reservation.status = 'failed'
                    reservation.error = error.message
                })
        })

        await Promise.all(promises)
        this.creating = false
    }

    /**
     * Indica si el usuario puede crear la lista de reservas en el dialogo de vista
     * previa. Habilita el botón "Crear"
     */
    public get canCreate () {
        return !this.newReservations.every(reservation => reservation.status === 'success')
    }

    /**
     * Envía una notificación WAMP a todos los componentes indicando que se ha registrado una nueva
     * reserva
     * @param reservation
     */
    public notifyNewReservation (reservation: Reservation) {
        if (!this.$wamp.session) {
            return
        }

        this.$wamp.publish('net.unigest.reservation_created', [reservation])
    }

    /**
     * Observa las notificaciones recibidas mediante WAMP indicando que una nueva
     * reserva se ha registrado
     */
    public watchNewReservationsNotification () {
        return this.$wamp.subscribe('net.unigest.reservation_created', (args: any[]) => {
            if (!_.isObject(args[0])) {
                return
            }

            const data = args[0] as KeyValuePair
            const reservation = Object.assign(new Reservation(), data, {
                dateStart: new Date(data.dateStart),
                dateEnd: new Date(data.dateEnd),
                department: Object.assign(new Department(), data.department),
                event: Object.assign(new Event(), data.event),
                operator: Object.assign(new User(), data.user),
            })

            this.reservations.push(reservation)
        })
    }

    public async created () {
        this.loading = true
        this.displayColorLegend = JSON.parse(
            localStorage.getItem('config.reservation.grid.displayColorLegend') || 'true',
        )
        this.displaySecondaryCalendar = JSON.parse(
            localStorage.getItem('config.reservation.grid.displaySecondaryCalendar') || 'false',
        )

        await this.$store.dispatch('reservation/loadEventList')
        this.loading = false

        try {
            await this.$wamp.connect()
            await this.watchNewReservationsNotification()
        } catch (error) {
        }
    }

    /**
     * Calcula el precio de la reserva actualmente en edición
     */
    public async loadReservationPrice () {
        if (!this.currentNewReservation) {
            return
        }

        const reservation = this.currentNewReservation
        this.loadingPrice = true

        reservation.price = await getReservationPrice({
            date: reservation.dateStart,
            department: reservation.department.id,
            services: reservation.services ? reservation.services.map(s => s.id) : this.createReservationsOptions.services.map(s => s.id),
        })

        this.loadingPrice = false
    }

    /**
     * Establece la reserva argumentada como nueva reserva en edición
     *
     * @param reservation
     */
    public async setCurrentNewReservation (reservation: Reservation) {
        this.currentNewReservation = reservation
        await this.loadReservationPrice()
    }
}
